
const openExternalUrl = (url) => {
  if (!url) return;
  try {
    window.webkit.messageHandlers.openURL.postMessage(url);
  } catch {
    window.open(url, "_blank", "noopener,noreferrer");
  }
};

export default openExternalUrl;
